import { useCallback } from 'react';

const useSkillRemovalFocus = ({ setNextFocus, skillsByCategory }) => {
  const setNextFocusAfterCategoryNavigation = useCallback(
    categoryId => {
      const currentCategoryIndex = skillsByCategory.findIndex(
        cat => cat.category.id === categoryId
      );
      const nextCategory = skillsByCategory[currentCategoryIndex + 1];

      if (nextCategory) {
        setNextFocus(nextCategory.category.id);

        return;
      }

      const prevCategory = skillsByCategory[currentCategoryIndex - 1];

      if (prevCategory) {
        const lastSkillInPrevCategory = prevCategory.skills.slice(-1)[0];

        if (lastSkillInPrevCategory) {
          setNextFocus(lastSkillInPrevCategory.id);

          return;
        }
      }

      setNextFocus(null);
    },
    [setNextFocus, skillsByCategory]
  );

  const setNextFocusAfterSkillRemoval = useCallback(
    (skill, filteredSkills) => {
      if (!setNextFocus) return;

      if (filteredSkills.length === 0) {
        setNextFocus(null);

        return;
      }

      const categoryData = skillsByCategory.find(
        cat => cat.category.id === skill.category.id
      );
      const skillsInCategory = categoryData?.skills || [];
      const currentSkillIndex = skillsInCategory.findIndex(
        s => s.id === skill.id
      );

      if (skillsInCategory.length > 1) {
        const nextIndex =
          currentSkillIndex < skillsInCategory.length - 1
            ? currentSkillIndex + 1
            : currentSkillIndex - 1;

        setNextFocus(skillsInCategory[nextIndex].id);

        return;
      }

      setNextFocusAfterCategoryNavigation(skill.category.id);
    },
    [setNextFocus, skillsByCategory, setNextFocusAfterCategoryNavigation]
  );

  const setNextFocusAfterCategoryRemoval = useCallback(
    (category, filteredSkills) => {
      if (!setNextFocus) return;

      if (filteredSkills.length === 0) {
        setNextFocus(null);

        return;
      }

      setNextFocusAfterCategoryNavigation(category.id);
    },
    [setNextFocus, setNextFocusAfterCategoryNavigation]
  );

  return {
    setNextFocusAfterSkillRemoval,
    setNextFocusAfterCategoryRemoval
  };
};

export default useSkillRemovalFocus;
